import React from 'react'

function TabletLandscape({ className }) {
  return (
    <svg
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon--tablet-landscape${className ? ' ' + className : ''}`}
    >
      <path d="M0 0h48v48h-48z" fill="none" />
      <path d="M42 8h-36c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h36c2.21 0 3.98-1.79 3.98-4l.02-24c0-2.21-1.79-4-4-4zm-4 28h-28v-24h28v24z" />
    </svg>
  )
}

export default TabletLandscape
